import Icon from "@shared/components/md-design-system/Icon/Icon";
import { colorPalette } from "@shared/config/colorsConfig";
import { DEVICE_ISSUE_TYPE } from "app/types/deviceIssue";
import { Trans } from "react-i18next";
import { Text, View } from "react-native";
import { TDeviceIssueConfig } from "../../constants/deviceIssueConfig";

const RedToGreen = () => {
  return (
    <View className="flex-row gap-4">
      <View className="h-5 w-5 rounded-full bg-error-500" />
      <Icon name="arrow-right" size={18} color={colorPalette.gray[500]}/>
      <View className="h-5 w-5 rounded-full bg-success-500 opacity-20" />
    </View>
  )
}

const getProblemIcon = (config: TDeviceIssueConfig) => {
  switch(config.page.deviceIssue) {
    case DEVICE_ISSUE_TYPE.gatewayDisconnected:
      return <RedToGreen />
    default:
      return <Icon name={config.icon} size={18} color={colorPalette.error[500]} />
  }
}

export const DeviceTroubleShootingProblemInfoBox = (config: TDeviceIssueConfig) => {
  const problemIcon = getProblemIcon(config)
  return (
    <View className="bg-gray-100 border border-gray-300 rounded-2xl p-4 flex-row items-center gap-3">
      {problemIcon}
      <Text className="flex-1 text-base">
        <Trans
          i18nKey={config.page?.problemKey as never}
          components={{
            ok: <Text className="text-success-700 font-semibold" />,
            bad: <Text className="text-error-500 font-semibold" />,
          }}
        />
      </Text>
    </View>
  )
}